import { useState } from "react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ChevronUp, ChevronDown, ChevronsUpDown } from "lucide-react";

export default function DataTable({ columns, data, onRowClick, className = "" }) {
  const [sortKey, setSortKey] = useState(null);
  const [sortDir, setSortDir] = useState("desc");

  const handleSort = (key) => {
    if (!key) return;
    if (sortKey === key) {
      setSortDir(sortDir === "asc" ? "desc" : "asc");
    } else {
      setSortKey(key);
      setSortDir("desc");
    }
  };

  const sorted = [...(data || [])].sort((a, b) => {
    if (!sortKey) return 0;
    const aVal = a[sortKey];
    const bVal = b[sortKey];
    if (typeof aVal === "number" && typeof bVal === "number") {
      return sortDir === "asc" ? aVal - bVal : bVal - aVal;
    }
    return sortDir === "asc"
      ? String(aVal).localeCompare(String(bVal))
      : String(bVal).localeCompare(String(aVal));
  });

  return (
    <div className={`overflow-auto ${className}`} data-testid="data-table">
      <Table>
        <TableHeader>
          <TableRow className="border-border hover:bg-transparent">
            {columns.map((col) => (
              <TableHead
                key={col.key}
                className={`text-xs uppercase tracking-wider font-semibold text-muted-foreground whitespace-nowrap ${col.sortable !== false ? "cursor-pointer select-none" : ""} ${col.align === "right" ? "text-right" : ""}`}
                onClick={() => col.sortable !== false && handleSort(col.key)}
                data-testid={`sort-${col.key}`}
              >
                <div className={`flex items-center gap-1 ${col.align === "right" ? "justify-end" : ""}`}>
                  {col.label}
                  {col.sortable !== false && (
                    sortKey === col.key ? (
                      sortDir === "asc" ? <ChevronUp size={14} /> : <ChevronDown size={14} />
                    ) : (
                      <ChevronsUpDown size={12} className="opacity-40" />
                    )
                  )}
                </div>
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {sorted.map((row, idx) => (
            <TableRow
              key={row.id || idx}
              className="border-border hover:bg-muted/50 transition-colors cursor-pointer"
              onClick={() => onRowClick?.(row)}
              data-testid={`table-row-${idx}`}
            >
              {columns.map((col) => (
                <TableCell
                  key={col.key}
                  className={`text-sm font-data whitespace-nowrap ${col.align === "right" ? "text-right" : ""}`}
                >
                  {col.render ? col.render(row[col.key], row) : row[col.key]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
